const CUSTOMER_MAP_DEV = {
  'b119af37-52cc-4334-b1f1-1420420871f3': 'damas-noos',
  '4ed120d8-f228-4b99-b4fe-4b486c2c944b': 'gemo',
} as const;

type DevSlugs = (typeof CUSTOMER_MAP_DEV)[keyof typeof CUSTOMER_MAP_DEV];

const CUSTOMER_MAP_PROD = {
  'b119af37-52cc-4334-b1f1-1420420871f3': 'damas-noos',
  '4ed120d8-f228-4b99-b4fe-4b486c2c944b': 'gemo',
} as const satisfies Record<string, DevSlugs>;

export const CUSTOMER_MAP =
  import.meta.env.MODE === 'production' ? CUSTOMER_MAP_PROD : CUSTOMER_MAP_DEV;
